import SupervisorAccountOutlined from '@mui/icons-material/SupervisorAccountOutlined';
import { Box, ButtonBase, Paper, Typography } from '@/shared/ui';

import { storage, StorageKeys } from '@/services/storage';
import { useStorageValue } from '@/services/storage/react';
import { redirectTo } from '@/shared/lib/url/navigation';
import { useAppSelector } from '@/store/hooks';

const exitImpostorMode = () => {
  const cached = storage.get(StorageKeys.CachedToken);
  if (storage.get(StorageKeys.GxToken) && cached) {
    storage.set(StorageKeys.GxToken, cached);
    storage.remove(StorageKeys.TripToken);
    storage.remove(StorageKeys.CachedToken);
    storage.remove(StorageKeys.Impersonator);
  }
};

export const ImpersonatorBanner = () => {
  const handleExitImpersonatorMode = () => {
    exitImpostorMode();
    redirectTo('/');
  };
  const impersonatorEmail = useStorageValue(StorageKeys.Impersonator);

  const tripTokenState = useAppSelector(state => state.tripToken);

  if (!impersonatorEmail) return null;
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        gap: 3
      }}
    >
      <Paper
        sx={{
          width: '100%',
          height: '48px',
          backgroundColor: 'gx.highlight',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          mb: 3
        }}
      >
        <Typography>
          You are logged in as <span style={{ fontWeight: 700 }}>{tripTokenState.userEmail}</span>
        </Typography>
        <ButtonBase
          sx={{
            width: 120,
            height: 32,
            ml: 3,
            px: 1,
            backgroundColor: 'gx.actionBarButtonTile',
            fontSize: 12
          }}
          onClick={handleExitImpersonatorMode}
        >
          <SupervisorAccountOutlined sx={{ fontSize: 18, mr: 0.5 }} /> Switch back
        </ButtonBase>
      </Paper>
    </Box>
  );
};
